import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import DeleteButton from '../DeleteButton';
import { MMMDYYYY } from '../../utils/time';
import checkmark from '../../img/icons/checkmark.svg';
import style from '../../style/components/signin/TwoFArow.module.scss';

const TwoFAActiveRow = ({
  date,
  handleDelete,
  handleUpdate,
  index,
  mfaPolicies,
  name,
  totalEnrolled,
}) => {
  const updateIsDefined = !!handleUpdate;
  const isOnly2FA = totalEnrolled === 1;

  const onClickDelete = useCallback(() => {
    handleDelete(index);
  }, [handleDelete, index]);

  const onClickUpdate = useCallback(() => {
    if (updateIsDefined) {
      handleUpdate(index);
    }
    // do nothing
  }, [handleUpdate, index, updateIsDefined]);

  return (
    <div className={style.rowActive}>
      <div data-testid="mfa-row-add-details" className={style.left}>
        <div className={style.name}>{name}</div>
        <div className={style.date}>Added {MMMDYYYY(date)}</div>
      </div>

      <div className={style.center}>
        {mfaPolicies.map((use, index) => (
          <div
            className={style.pill}
            data-testid={`mfa-row-use-${use}`}
            key={index}
          >
            <img alt="" src={checkmark} />
            <span>{use}</span>
          </div>
        ))}
      </div>

      <div className={style.right}>
        {updateIsDefined && (
          <idme-button
            data-testid="mfa-row-rename-button"
            variant="tertiary"
            size="small"
            text="Rename"
            onClick={onClickUpdate}
          />
        )}
        {!isOnly2FA && <DeleteButton onClick={onClickDelete} />}
      </div>
    </div>
  );
};

TwoFAActiveRow.propTypes = {
  date: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func,
  index: PropTypes.number.isRequired,
  mfaPolicies: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
  totalEnrolled: PropTypes.number.isRequired,
};

export default memo(TwoFAActiveRow);
